import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=8b75441c&scoped=true"
import script from "./GoToTop.vue?vue&type=script&lang=js"
export * from "./GoToTop.vue?vue&type=script&lang=js"
import style0 from "./GoToTop.vue?vue&type=style&index=0&id=8b75441c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b75441c",
  null
  
)

export default component.exports